import { Pipe, PipeTransform } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Pipe({ name: 'AccessRightsPipe' })
export class AccessRightsPipe implements PipeTransform {
  access_rights_json;
  constructor(private http?: HttpClient) {
    this.http.get('assets/data/access_right.json').subscribe(res => {
      if (res) {
        this.access_rights_json = res
      }
    })
  }
  transform(access_rights, name, cr_user_id, team) {
    if (access_rights) {
      try {
        return eval(this.access_rights_json[name])
      } catch (err) {
        return false
      }
    }
  }
}
